"use strict";
module.exports = {
    entityModel: 'invite',
    events: {
        INVITE_UPDATED: 'INVITE_UPDATED',
        INVITE_CREATED: 'INVITE_CREATED',
    },
    actions: {
        get: 'v1.invite.get',
        list: 'v1.invite.list',
        sendCustomerSubUnitInvite: 'v1.invite.sendCustomerSubUnitInvite',
        sendSupplierCustomerInvite: 'v1.invite.sendSupplierCustomerInvite',
        sendPurchasingInvite: 'v1.invite.sendPurchasingInvite',
        accept: 'v1.invite.accept',
        upsert: 'v1.invite.upsert',
        upsertWhenEmpty: 'v1.invite.upsertWhenEmpty',
        updateWhenEmpty: 'v1.invite.updateWhenEmpty',
        update: 'v1.invite.update',
    },
    roles: {
        customerSubUnitAdmin: 'customerSubUnitAdmin',
        customerSubUnitPurchaser: 'customerSubUnitPurchaser',
        customerSubUnitPurchaserManager: 'customerSubUnitPurchaserManager',
        customerSubUnitPurchaserAssociateManager: 'customerSubUnitPurchaserAssociateManager',
    },
};
